import { compact } from 'lodash';
import { useMutation } from 'react-query';

import { postNotification } from 'queries';
import { Toast } from 'helpers';
import { JsonDataItem } from 'types';
import { SendNotification } from 'components';

export const useSendJobNotification = (
  job: JsonDataItem | null,
  technician: JsonDataItem | null,
  type: SendNotification.Type | null,
) => {
  const technicianEmail = technician?.email;
  const technicianMobile = technician?.mobile?.[0];
  const customerEmail = job?.customer?.email;
  const customerMobile = job?.customer?.contact1.contact1_mobile?.trim();
  const customerSecondaryMobile = job?.customer?.contact2.contact2_mobile?.trim();

  const initialValues = {
    emailNotification: compact([technicianEmail && 'technicianEmail', customerEmail && 'customerEmail']),
    smsNotification: compact([technicianMobile && 'technicianMobile', customerMobile && 'customerMobile']),
  };

  const emailOptions = compact([
    technicianEmail && {
      label: `Technician - ${technicianEmail}`,
      value: 'technicianEmail',
    },
    customerEmail && {
      label: `Customer Primary - ${customerEmail}`,
      value: 'customerEmail',
    },
  ]);

  const smsOptions = compact([
    technicianMobile && {
      label: `Technician - ${technicianMobile}`,
      value: 'technicianMobile',
    },
    customerMobile && {
      label: `Customer Primary - ${customerMobile}`,
      value: 'customerMobile',
    },
    customerSecondaryMobile && {
      label: `Customer Secondary - ${customerSecondaryMobile}`,
      value: 'customerSecondaryMobile',
    },
  ]);

  const {
    mutate,
    isLoading: isNotifying,
    isSuccess: isNotified,
  } = useMutation(postNotification, {
    onSuccess: () => {
      Toast.show({
        description: 'Notifications have been sent.',
        type: Toast.Type.Success,
      });
    },
    onError: () => {
      Toast.show({ description: 'Error notifying customer', type: Toast.Type.Error });
    },
  });

  const sendNotifications = (data: JsonDataItem) => {
    mutate({
      recipients: [...data.emailNotification, ...data.smsNotification],
      serviceId: job?.ID,
      notificationType: type,
    });
  };

  return {
    sendNotifications,
    isNotifying,
    initialValues,
    emailOptions,
    smsOptions,
    isNotified,
  };
};
